export enum PageTypes {
    ArticlePage = 'articlePage',
    AviouPage = 'aviouPage',
    BasketPage = 'basketPage',
    BrandPage = 'brandPage',
    CheckoutPage = 'checkoutPage',
    ClubFavoriteStorePage = 'clubFavoriteStorePage',
    ClubInvoicesPage = 'clubInvoicesPage',
    ClubPage = 'clubPage',
    ClubStandardPage = 'clubStandardPage',
    ClubPersonalInfoPage = 'clubPersonalInfoPage',
    ErrorPage = 'errorPage',
    OrderConfirmationPage = 'orderConfirmationPage',
    ProductDetailPage = 'productDetailPage',
    ProductFilterPage = 'productFilterPage',
    Recipe = 'recipes',
    RecipePage = 'recipePage',
    RootPage = 'rootPage',
    SearchPage = 'searchPage',
    StandardPage = 'standardPage',
    StorePage = 'storePage',
    StoresPage = 'storesOverviewPage'
}
